// Side-menu grouping: where a group heading goes in a filtered item list.

/** True when item i starts a group: it has a group and the item before it doesn't share it. */
export function startsGroup(items: Array<{ group?: string }>, i: number): boolean {
  const g = items[i]?.group
  return !!g && items[i - 1]?.group !== g
}

/** True when item i is the first ungrouped item after a group, so it needs breathing room. */
export function endsGroup(items: Array<{ group?: string }>, i: number): boolean {
  return !items[i]?.group && !!items[i - 1]?.group
}

/** Console pages an operator (Customer Support staff) may open; everything else sends them to the desk. */
const OPERATOR_PAGES = ['/support', '/help/reply-desk', '/known-issues', '/unthreaded', '/email', '/desk', '/issue-announcements', '/campaigns-desk']

export function operatorMayOpen(path: string): boolean {
  return OPERATOR_PAGES.some((p) => path === p || path.startsWith(p + '/'))
}
